<div class="jepto-number-chart">
	@if (metricLabel()) {
		<div class="jepto-number-chart__metric-label">{{ metricLabel() }}</div>
	}

	<div class="jepto-number-chart__value" [class]="valueSizeClass()">
		@if (prefix()) {
			<span class="jepto-number-chart__prefix">{{ prefix() }}</span>
		}
		<span class="jepto-number-chart__number">{{ formattedValue() }}</span>
		@if (suffix()) {
			<span class="jepto-number-chart__suffix">{{ suffix() }}</span>
		}
		@if (valueDetail()) {
			<span class="jepto-number-chart__value-detail">{{ valueDetail() }}</span>
		}
	</div>

	@if (hasComparison()) {
		<div
			class="jepto-number-chart__comparison"
			[class.jepto-number-chart__comparison--up]="
				changeDirection() === 'up'
			"
			[class.jepto-number-chart__comparison--down]="
				changeDirection() === 'down'
			"
			[class.jepto-number-chart__comparison--flat]="
				changeDirection() === 'flat'
			"
		>
			<span class="jepto-number-chart__comparison-value">
				{{ comparisonPillText() }}
			</span>
		</div>
	}

	@if (showSparkline() && sparklineHeight() > 0) {
		<div
			#sparklineContainer
			class="jepto-number-chart__sparkline"
			[style.height.px]="sparklineHeight()"
		></div>
	}
</div>
